"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateThirdPartyScriptConfig = exports.getThirdPartyScriptConfig = exports.fetchServerSideHtml = exports.dispatchCustomEvent = exports.applyStylingTransformations = exports.TPS_TITLE = exports.DefaultHeaderColorConfig = exports.DEFAULT_HEADER_SECTION_TITLE = exports.CUSTOM_CODE = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _MappedVariables = _interopRequireDefault(require("@insided/deprecated-preact-components/theme-configuration/MappedVariables"));

var _tinycolor = _interopRequireDefault(require("tinycolor2"));

var _axios = _interopRequireDefault(require("axios"));

var DEFAULT_HEADER_SECTION_TITLE = {
  Logo: 'Logo',
  Link: 'Link',
  Style: 'Style'
};
exports.DEFAULT_HEADER_SECTION_TITLE = DEFAULT_HEADER_SECTION_TITLE;
var TPS_TITLE = {
  Head: 'INSERT IN <HEAD>',
  AfterBodyOpening: 'INSERT RIGHT AFTER <BODY> TAG',
  BeforeBodyClosing: 'INSERT BEFORE </BODY> TAG'
};
exports.TPS_TITLE = TPS_TITLE;
var CUSTOM_CODE = {
  CustomHTML: {
    title: 'Custom HTML',
    description: 'We recommend inviting a professional web developer to work with custom code. We strongly recommend testing in your staging environment first.'
  },
  TPSHead: {
    title: "Add Scripts in <HEAD>",
    description: "Use for scripts needed in Head, like third-party libraries, metadata, or fonts."
  },
  TPSAfterBodyOpening: {
    title: "Add Scripts at the top of <BODY>",
    description: "Use for scripts that should run early in the body, such as analytics or tag managers."
  },
  TPSBeforeBodyClosing: {
    title: "Add Scripts at the bottom of <BODY>",
    description: "Use for scripts that should load after the main body content e.g., widgets, chatbots, or deferred JS."
  }
};
exports.CUSTOM_CODE = CUSTOM_CODE;
var DefaultHeaderColorConfig = [{
  title: 'Background Color',
  key: 'backgroundColor',
  description: 'Define the background color for the site header'
}, {
  title: 'Link Color',
  key: 'linkColor',
  description: 'Text color of the link in the site header'
}];
exports.DefaultHeaderColorConfig = DefaultHeaderColorConfig;

var dispatchCustomEvent = function dispatchCustomEvent(eventName, newValue) {
  var customEvent = new CustomEvent(eventName, {
    detail: {
      value: newValue
    }
  });
  window.dispatchEvent(customEvent);
};

exports.dispatchCustomEvent = dispatchCustomEvent;

var fetchServerSideHtml = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(url, cancelToken) {
    var response;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return _axios.default.get("/configuration/fetch-ssi?url=".concat(encodeURIComponent(url)), {
              cancelToken: cancelToken
            });

          case 3:
            response = _context.sent;
            return _context.abrupt("return", response.data);

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", 'Failed to fetch');

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 7]]);
  }));

  return function fetchServerSideHtml(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

exports.fetchServerSideHtml = fetchServerSideHtml;

var applyStylingTransformations = function applyStylingTransformations(updatedStyling, currentStyling) {
  var currentStylingConfig = currentStyling !== null && currentStyling !== void 0 ? currentStyling : updatedStyling;
  Object.keys(_MappedVariables.default).forEach(function (variable) {
    var _currentStylingConfig;

    var value = _MappedVariables.default[variable];

    if (typeof value === 'string') {
      updatedStyling[variable] = currentStylingConfig[value];
      return;
    }

    var newColor = (_currentStylingConfig = currentStylingConfig[value.name]) !== null && _currentStylingConfig !== void 0 ? _currentStylingConfig : undefined;

    if (value.alpha) {
      updatedStyling[variable] = (0, _tinycolor.default)(newColor).setAlpha(value.alpha).toHex8String();
    } else if (value.darken) {
      updatedStyling[variable] = (0, _tinycolor.default)(newColor).darken(value.darken).toHex8String();
    } else if (value.brighten) {
      updatedStyling[variable] = (0, _tinycolor.default)(newColor).brighten(value.brighten).toHex8String();
    }
  });
  return updatedStyling;
};

exports.applyStylingTransformations = applyStylingTransformations;

var getThirdPartyScriptConfig = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
    var res;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return _axios.default.get('/configuration/getThirdPartyScripts');

          case 2:
            res = _context2.sent;
            return _context2.abrupt("return", res.data);

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getThirdPartyScriptConfig() {
    return _ref2.apply(this, arguments);
  };
}();

exports.getThirdPartyScriptConfig = getThirdPartyScriptConfig;

var updateThirdPartyScriptConfig = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(scripts) {
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _axios.default.post('/configuration/updateThirdPartyScripts', scripts);

          case 2:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function updateThirdPartyScriptConfig(_x3) {
    return _ref3.apply(this, arguments);
  };
}();

exports.updateThirdPartyScriptConfig = updateThirdPartyScriptConfig;